import axios, { AxiosError } from 'axios'
import { auth }               from './firebase'
import toast                  from 'react-hot-toast'

// ── Instância base ───────────────────────────────────────
export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// ── Interceptor de request: injeta JWT do Firebase ──────
api.interceptors.request.use(async (config) => {
  const user = auth.currentUser
  if (user) {
    const token = await user.getIdToken()
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// ── Interceptor de response: tratamento de erros ────────
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ message?: string; error?: string }>) => {
    const status  = error.response?.status
    const message = error.response?.data?.message
                 || error.response?.data?.error
                 || 'Algo deu errado. Tente novamente.'

    // Token expirado ou inválido → redireciona para login
    if (status === 401) {
      auth.signOut()
      window.location.href = '/login'
      return Promise.reject(error)
    }

    // Limite de plano atingido → redireciona para upgrade
    if (status === 402) {
      toast.error('Limite do plano atingido. Faça upgrade para continuar.')
      window.location.href = '/upgrade'
      return Promise.reject(error)
    }

    // Rate limit
    if (status === 429) {
      toast.error('Muitas requisições. Aguarde um momento.')
      return Promise.reject(error)
    }

    // Erros de servidor
    if (status && status >= 500) {
      toast.error('Erro interno. Nossa equipe foi notificada.')
      return Promise.reject(error)
    }

    return Promise.reject({ ...error, message })
  },
)

export default api
